import { fetcher } from "helpers/fetcher";

import { TDeleteFileReq, TDeleteFileRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteStaffFile = async (payload: TDeleteFileReq) => {
  return await fetcher<TDeleteFileRes, TDeleteFileReq["data"]>(
    ENDPOINT.USER.DELETE_STAFF_FILE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.DELETE_STAFF_FILE.version,
      },
    }
  );
};

export const mutationDeleteStaffFile = async (payload: TDeleteFileReq) => {
  return (await deleteStaffFile(payload)).data.message;
};

mutationDeleteStaffFile._key = (payload: TDeleteFileReq) => [
  ENDPOINT.USER.DELETE_STAFF_FILE.url,
  payload,
];
